import styled from 'styled-components';

const ClickableText = styled.span<{ color: string; align?: string }>`
  color: ${({ color }) => color};
  cursor: pointer;
  text-align: ${({ align }) => (align || 'initial')};
  margin: 0 4px;

  &:hover {
    text-decoration: underline;
  }
`;

export default ClickableText;
